import StepImg1 from '../../../../images/NextSteps/formNameLocationContact.jpg'
import StepImg2 from '../../../../images/NextSteps/formPersonal.jpg'
import StepImg3 from '../../../../images/NextSteps/formSocial.jpg'
import StepImg4 from '../../../../images/NextSteps/formTestimonials.jpg'
import StepImg5 from '../../../../images/NextSteps/formPhotos.jpg'
import StepImg6 from '../../../../images/NextSteps/formFacilities.jpg'
import StepImg71 from '../../../../images/NextSteps/formExperience.jpg'
import StepImg72 from '../../../../images/NextSteps/formServicesSkillsTools.jpg'

import StepIcon1 from '../../../../images/NextSteps/icon/location flag icon.gold.png'
import StepIcon2 from '../../../../images/NextSteps/icon/light bulb person.gold.png'
import StepIcon3 from '../../../../images/NextSteps/icon/conversation bubbles.gold.png'
import StepIcon4 from '../../../../images/NextSteps/icon/star.gold.png'
import StepIcon5 from '../../../../images/NextSteps/icon/portrait icon.gold.png'
import StepIcon6 from '../../../../images/NextSteps/icon/clubhouse.gold.png'

const steps = [
  {
    image: StepImg1,
    icon: StepIcon1,
    title: 'Name, Location, Contact:',
    text:
      'These fields are self explanatory but do ensure all information is accurate. PRO TIP: Prospects make quick judgments based on your photos. Make sure what you upload looks friendly, open and accessible.'
  },
  {
    image: StepImg2,
    icon: StepIcon2,
    title: 'Personal:',
    text:
      'In this field you have 1,000 words to describe yourself. As with your photos, you can make a real impression here. Don’t be afraid to reveal things about yourself like inspirations, heroes, and your own goals and philosophy about the game and coaching.'
  },
  {
    image: StepImg3,
    icon: StepIcon3,
    title: 'Social:',
    text:
      'If you have a presence on any social platforms, copy and paste the URL to your personal pages next to the appropriate social media icon.'
  },
  {
    image: StepImg4,
    icon: StepIcon4,
    title: 'Testimonials:',
    text: 'Copy and paste up to five testimonials here.'
  },
  {
    image: StepImg5,
    icon: StepIcon5,
    title: 'Photos:',
    text:
      'Again, prospects like seeing photos within your profile. Make sure the ones you upload here are the best of your best.'
  },
  {
    image: StepImg6,
    icon: StepIcon6,
    title: 'Facilities:',
    text:
      'It’s fine to copy and paste information from your facility’s website in these fields. Just ensure all of the information is accurate. In Facility Offerings, if you paste nothing in this field, please click the delete button to eliminate empty fields in your profile.'
  },
  {
    image: StepImg71,
    image2: StepImg72,
    title: 'Experience, Services, Skills, Tools:',
    text:
      'These fields are tick boxes. Check all that apply to you. If there are no specific tools you want to list in this field, please click the delete button to eliminate empty fields in your profile.'
  }
]

export default steps
